import React from 'react'
import EnhancedContactManager from 'src/enhanced_contact_manager/containers/EnhancedContactManager'
import { useAccount } from 'src/hooks'
import { RelationshipManagerRoute } from '../routes/RelationshipManagerRoute'
import ContactManager from './ContactManager'

type ContactManagerSelectorProps = {
  route: RelationshipManagerRoute | undefined
}

const ContactManagerSelector: React.FC<ContactManagerSelectorProps> = props => {
  const { route } = props
  const account = useAccount()
  return (
    <>
      {account.hasFullAccessContactManager ? (
        <EnhancedContactManager route={route} />
      ) : (
        <ContactManager route={route} />
      )}
    </>
  )
}

export default ContactManagerSelector
